module.exports = function(app) {

    app.directive('limitSpecialCharacters', ['teamsite', function (teamsite) {
        return {
            restrict: 'A',
            replace: false,
            controller: [function () {
            }],
            link: function (scope, element, attrs, controller) {
                var removeSomeAllowOthers = function(theStr) {
                    // we want to allow space, hyphen, and apostrophe but not other special characters
                    var regSp1 = /[*!@#$%^&_.,]/gi;
                    theStr = theStr.replace(regSp1, '');
                    var regSp2 = /[()+={}[\]]/gi;
                    theStr = theStr.replace(regSp2, '');
                    var regSp3 = /[;:~`"<>?/\\|]/gi;
                    theStr = theStr.replace(regSp3, '');
                    return theStr;
                }
                // This is used to respond to keystrokes made in <input> boxes
                scope.$watch('demogItems.firstName', function(theVal) {
                    if (typeof theVal == 'undefined') {
                        return;
                    } else {
                        // we want to allow space, hyphen, and apostrophe
                        theVal = removeSomeAllowOthers(theVal);
                        scope.demogItems.firstName = theVal;
                    }
                });
                scope.$watch('demogItems.lastName', function(theVal) {
                    if (typeof theVal == 'undefined') {
                        return;
                    } else {
                        // we want to allow space, hyphen, and apostrophe
                        theVal = removeSomeAllowOthers(theVal);
                        scope.demogItems.lastName = theVal;
                    }
                });
                scope.$watch('demogItems.address', function(theVal) {
                    if (typeof theVal == 'undefined') {
                        return;
                    } else {
                        // we want to allow space, hyphen, and apostrophe
                        theVal = removeSomeAllowOthers(theVal);
                        scope.demogItems.address = theVal;
                    }
                });
                scope.$watch('demogItems.city', function(theVal) {
                    if (typeof theVal == 'undefined') {
                        return;
                    } else {
                        // we want to allow space, hyphen, and apostrophe
                        theVal = removeSomeAllowOthers(theVal);
                        scope.demogItems.city = theVal;
                    }
                });
            }
        };
    }]);

    
    app.directive('hasOneAlphaAndOneDigit', ['teamsite', function (teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/demogs/has-one-alpha-and-one-digit.html'),
            controller: [function () {
            }],
            link: function (scope, element, attrs, controller) {
                var hasAlphaAndNumeric = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.hasAlphaAndNumeric = function () {
                    hasAlphaAndNumeric = false;
                    var hasAlpha = false;
                    var hasNumeric = false;
                    var displayLoginId = scope.demogItems.displayLoginId;
                    var arrD = displayLoginId.split('');
                    for (var i = 0; i < arrD.length; i++) {
                        var matchesLetters = arrD[i].match(/[A-Za-z]/);
                        hasAlpha = matchesLetters ? true : hasAlpha;
                        var matchesNumbers = arrD[i].match(/[0-9]/);
                        hasNumeric = matchesNumbers ? true : hasNumeric;
                    }
                    hasAlphaAndNumeric = hasAlpha && hasNumeric;
                    if (hasAlphaAndNumeric) {
                        hideMsg();
                    } else {
                        showMsg();
                    }
                    return hasAlphaAndNumeric;
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('demogItems.displayLoginId', function () {
                    var formIdIsValid = scope.demogForm.displayLoginId.$valid;  // has the default validations for password cleared?
                    var submitWasClicked = scope.submitWasAlreadyClicked;
                    if (submitWasClicked && formIdIsValid) {
                        scope.valStuff.hasAlphaAndNumeric();
                    } else {
                        return;
                    }
                })
                scope.$watch('demogItems.displayLoginId', function(theVal) {
                    if (typeof theVal == 'undefined') {
                        return;
                    } else {
                        // dont allow spaces, special chars
                        //    !@#$%^&*()_-+={[}]|\\?/><:;~              /[-*!@#$%^&_.,]/gi;
                        var regSp1 = /[-*!@#$%^&_.,]/gi;
                        theVal = theVal.replace(regSp1, '');
                        var regSp2 = /[()+={}[\]]/gi;
                        theVal = theVal.replace(regSp2, '');
                        var regSp3 = /[;:~`"'<>?/\\|]/gi;
                        theVal = theVal.replace(regSp3, '');
                        var regSp = /[ ]/gi;
                        theVal = theVal.replace(regSp, '');
                        var allCaps = theVal.toUpperCase();
                        scope.demogItems.displayLoginId = allCaps;
                    }
                });
                var hideMsg = function () {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-has-one-alpha-and-one-digit ='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function () {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-has-one-alpha-and-one-digit = 'true']").removeClass("hide-val-msg").addClass("show-val-msg");
                }
            }
        };
    }]);

    app.directive('pwdHasNoSpace', ['teamsite', function (teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/demogs/pwd-has-no-space.html'),
            controller: [function () {
            }],
            link: function (scope, element, attrs, controller) {
                var pwdHasNoSpace = false;  // we want this to be true. - spaces are not allowed in the password
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.pwdHasNoSpace = function () {
                    pwdHasNoSpace = true;
                    var searchObj = scope.demogItems;
                    if (searchObj.password && searchObj.password.length > 0 ) {
                        var pwd = searchObj.password;
                        for (var i=0; i < pwd.length; i++) {
                            pwdHasNoSpace = (pwd[i] == ' ' ) ? false : pwdHasNoSpace;
                        }
                        if (pwdHasNoSpace) {
                            hideMsg();
                        } else {
                            showMsg();
                        }
                    } else {
                        pwdHasNoSpace = true;
                        hideMsg();
                    }
                    return pwdHasNoSpace;
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('demogItems.password', function () {
                    if (scope.submitWasAlreadyClicked) {
                        scope.valStuff.pwdHasNoSpace();
                    }
                })
                var hideMsg = function () {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-pwd-has-no-space ='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function () {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-pwd-has-no-space = 'true']").removeClass("hide-val-msg").addClass("show-val-msg");
                    pwdHasNoSpace = false;
                }
            }
        };
    }]);
    app.directive('confirmPwdMatches', ['teamsite', function (teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/demogs/confirm-pwd-matches.html'),
            controller: [function () {
            }],
            link: function (scope, element, attrs, controller) {
                var confirmPwdMatches = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.confirmPwdMatches = function () {
                    confirmPwdMatches = false;
                    var formPwdValue = scope.demogItems.password;
                    var confirmFormPwdValue = scope.demogItems.password2;
                    if (formPwdValue === confirmFormPwdValue) {
                        hideMsg();
                        confirmPwdMatches = true;
                    } else {
                        showMsg();
                    }
                    return confirmPwdMatches;
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('demogItems.password2', function () {
                    var formPwdIsValid = scope.demogForm.password.$valid;  // has the default validations for password cleared?
                    var submitWasClicked = scope.submitWasAlreadyClicked;
                    if (submitWasClicked && formPwdIsValid) {
                        scope.valStuff.confirmPwdMatches();
                    } else {
                        return;
                    }
                })
                var hideMsg = function () {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-confirm-pwd-matches ='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function () {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-confirm-pwd-matches = 'true']").removeClass("hide-val-msg").addClass("show-val-msg");
                    confirmPwdMatches = false;
                }
            }
        };
    }]);
    
    app.directive('passwordCharactersAreCorrect', ['teamsite', function (sessionData) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/demogs/password-characters-are-correct.html'),
            controller: [function () {
            }],
            link: function (scope, element, attrs, controller) {
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.passwordCharactersAreCorrect = function () {
                    var arrPassingRules = [];
                    var formPwdValue = scope.demogItems.password;
                    var dd = sessionData;
                    // ! @ # $ % ^ & * ( ) _ - + = { [ } ] | \ ? / > . < , : ;
                    var specialChars = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "_", "-", "+", "=", "{", "[", "}",
                        "]", "|", "\\", "?", "/", ">", "<", ",", ":", ";", "~" ]
                    var hasSpecialChar = false;
                    for (var i=0; i<specialChars.length; i++) {
                        hasSpecialChar = (formPwdValue.indexOf(specialChars[i])>-1) ? true : hasSpecialChar;
                    }
                    if (hasSpecialChar) { arrPassingRules.push(hasSpecialChar); }
                    // upper case letter --------------------------------------------------------------
                    var arrPwdLetters = formPwdValue.split('');
                    var hasCapital = false;
                    for (var j=0; j<arrPwdLetters.length; j++) {
                        var arr =  arrPwdLetters[j].match(/[A-Z]/); // if no match arr == null, otherwise an array
                        hasCapital = (arr) ? true : hasCapital;
                    }
                    if (hasCapital) { arrPassingRules.push(hasCapital); }
                    // lower case letter --------------------------------------------------------------
                    var hasLower = false;
                    for (var j=0; j<arrPwdLetters.length; j++) {
                        var arr2 =  arrPwdLetters[j].match(/[a-z]/); // if no match arr == null, otherwise an array
                        hasLower = (arr2) ? true : hasLower;
                    }
                    if (hasLower) { arrPassingRules.push(hasLower); }
                    // a number ------------------------------------------------------------------------
                    var hasNumber = false;
                    for (var j=0; j<arrPwdLetters.length; j++) {
                        var arr3 =  arrPwdLetters[j].match(/[0-9]/); // if no match arr == null, otherwise an array
                        hasNumber = (arr3) ? true : hasNumber;
                    }
                    if (hasNumber) { arrPassingRules.push(hasNumber); }
                    // hide the message if the pwd passes three of the four rules
                    var passesThreeRules = (arrPassingRules.length >=3);
                    if (passesThreeRules) {
                        hideMsg();
                    } else {
                        showMsg();
                    }
                    return passesThreeRules;
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('demogItems.password', function () {
                    var formPwdIsValid = scope.demogForm.password.$valid;  // has the default validations for password cleared?
                    var submitWasClicked = scope.submitWasAlreadyClicked;
                    if (submitWasClicked && formPwdIsValid) {
                        scope.valStuff.passwordCharactersAreCorrect();
                    } else {
                        return;
                    }
                })
                var hideMsg = function () {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-password-characters-are-correct ='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function () {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-password-characters-are-correct = 'true']").removeClass("hide-val-msg").addClass("show-val-msg");
                    passwordCharactersAreCorrect = false;
                }
            }
        };
    }]);

    app.directive('stateIsSelected', ['teamsite', function (teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/demogs/state-is-selected.html'),
            controller: [function () {
            }],
            link: function (scope, element, attrs, controller) {
                var stateIsSelected = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.stateIsSelected = function () {
                    stateIsSelected = false;
                    var searchObj = scope.demogItems;
                    if (((typeof searchObj.state) == 'undefined') || (searchObj.state.length == 0)) {
                        showMsg();
                    } else {
                        stateIsSelected = true;
                        hideMsg();
                    }
                    return stateIsSelected;
                }
                // this runs on $watch, when any member obj property changes --------------------------
                var reEvalTheForm = function () {
                    if (scope.submitWasAlreadyClicked) {
                        scope.valStuff.stateIsSelected();
                    }
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('demogItems.state', function () {
                    reEvalTheForm();
                })
                var hideMsg = function () {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-state-is-selected ='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function () {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-state-is-selected = 'true']").removeClass("hide-val-msg").addClass("show-val-msg");
                    stateIsSelected = false;
                }
            }
        };
    }]);

}
